import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() label: string;
  @Input() type: 'button' | 'submit' | 'file' = 'button';
  @Input() class: 'primary' | 'secondary' | 'danger'
  @Input() otherClass: string;
  @Input() title: string;
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() icon?: 'ver' | 'aprobar' | 'rechazar' | 'solicitar' | 'ingresar' | 'descargar';

  @Output() clicked = new EventEmitter<void>();

  onClick() {
    if (!this.disabled && !this.loading) {
      this.clicked.emit();
    }
  }
}
